import React, { useRef, useEffect } from "react"
import PropTypes from "prop-types"

export default function OutsideClickTrigger({ children, modifier, onOutsideClick }) {
  const wrapperRef = useRef(null)

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      if (onOutsideClick) onOutsideClick()
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div ref={wrapperRef} className={modifier}>
      {children}
    </div>
  )
}

OutsideClickTrigger.propTypes = {
  children: PropTypes.element.isRequired,
  modifier: PropTypes.string,
  onOutsideClick: PropTypes.func,
}
